import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested, IsBoolean, IsOptional } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class BSPBookingItemMatch {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  lastName!: string;
  @IsString()
  @Expose()
  ticketNumber!: string;
  @IsNumber()
  @Expose()
  grandTotal!: number;
  @IsOptional()
  @IsString()
  @Expose()
  formOfPayment!: string;
  @IsBoolean()
  @Expose()
  isClone!: boolean;
  @IsBoolean()
  @Expose()
  isMatchBSP!: boolean;
}

export class BSPBookingItemMatchResponse extends GenericTableResponse<BSPBookingItemMatch> {
  @Expose()
  @IsArray()
  @Type(() => BSPBookingItemMatch)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BSPBookingItemMatch>;
}
